/**
 * 삭제 확인 문구 — 회차가 여럿일 때만 몇 번째인지 밝힌다.
 *
 * 기록이 하나뿐인 곳에 "1번째 기록을 삭제할까요?"라고 물으면 있지도 않은
 * 2번째를 있는 것처럼 들리게 한다.
 */
export function deleteReviewMessage(visitNumber?: number | null): string {
  return visitNumber && visitNumber > 1
    ? `${visitNumber}번째 기록을 삭제하시겠어요?`
    : '기록을 삭제하시겠어요?'
}
